export default {"src":"/_next/static/media/record-audio.f15b2577.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};